import { render, staticRenderFns } from "./Corporateimages.vue?vue&type=template&id=6df10994&scoped=true"
import script from "./Corporateimages.vue?vue&type=script&lang=js"
export * from "./Corporateimages.vue?vue&type=script&lang=js"
import style0 from "./Corporateimages.vue?vue&type=style&index=0&id=6df10994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df10994",
  null
  
)

export default component.exports